import classNames from 'classnames';
import { Children, cloneElement, isValidElement } from 'react';

import useStyles from './styles';
import { IFileCardList } from './types';

function FileCardList({
  className,
  children,
  disabled,
  format,
  onDelete,
  onPreview,
}: IFileCardList) {
  const classes = useStyles();

  return (
    <ul className={classNames(classes.root, className)}>
      {Children.map(children, (child, index) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ...(disabled !== undefined ? { disabled } : {}),
            ...(format !== undefined ? { format } : {}),
            ...(onDelete != undefined ? { onDelete: () => onDelete(index) } : {}),
            ...(onPreview != undefined ? { onPreview: () => onPreview(index) } : {}),
          });
        }

        return child;
      })}
    </ul>
  );
}

export default FileCardList;
